export const TICKET_ROUTES = {
  OVERVIEW: '/tickets/overview/' as const,
};
